/**
 * Default layout for the Leaderboard page.
 *
 * The Leaderboard uses a unique custom rendering with animated ranking cards,
 * metric toggles, and special effects that don't map to standard widget types.
 * This minimal default provides a placeholder layout with two side-by-side
 * tables for Top Closers and Top Setters.
 */

import type { DashboardLayout } from "../types";

export const LEADERBOARD_DEFAULT: DashboardLayout = {
  widgets: [
    {
      id: "lb-table-closers",
      type: "table",
      title: "Top Closers",
      config: { dataKey: "topClosers", title: "Top Closers" },
    },
    {
      id: "lb-table-setters",
      type: "table",
      title: "Top Setters",
      config: { dataKey: "topSetters", title: "Top Setters" },
    },
  ],

  gridLayout: [
    { i: "lb-table-closers", x: 0, y: 0, w: 6, h: 16 },
    { i: "lb-table-setters", x: 6, y: 0, w: 6, h: 16 },
  ],
};
